<template>
    <el-dialog width="480px" v-model="dialogVisible" :close-on-click-modal="true" draggable :show-close="false">
        <el-form :model="form" label-position="right" v-loading="loading">
            <div :class="form.posSide === constants.SHORT ? 'title red' : 'title green'">{{ title }}</div>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="成交量" label-width="100px">
                        <div class="transamount">{{ form.TransAmount }} U</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="开启" label-width="100px">
                        <el-col :span="12">
                            <el-checkbox v-model="allowTakeProfit" style="width:100px">止盈</el-checkbox>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="allowStopLoss" style="width:100px">止损</el-checkbox>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;">
                <el-col :span="24">
                    <el-form-item label="触发类型" label-width="100px">
                        <el-col :span="12">
                            <el-select v-model="form.tpWorkingType" placeholder="止盈" style="width:130px"
                                @change="handleChange('TP')">
                                <el-option label="标记" :value="constants.MARK"></el-option>
                                <el-option label="最新" :value="constants.LAST"></el-option>
                                <el-option label="指数" :value="constants.INDEX"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-select v-model="form.slWorkingType" placeholder="止损" style="width:130px"
                                @change="handleChange('SL')">
                                <el-option label="标记" :value="constants.MARK"></el-option>
                                <el-option label="最新" :value="constants.LAST"></el-option>
                                <el-option label="指数" :value="constants.INDEX"></el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 20px;">
                <el-col :span="24">
                    <el-form-item label="盈亏目标" label-width="100px">
                        <el-col :span="12">
                            <el-tag type="warning" size="large" style="width: 130px;">
                                止盈 {{ form.TakeProfit }}%&nbsp;-&nbsp;{{ form.TakeProfitAmount }} U
                            </el-tag>
                        </el-col>
                        <el-col :span="12">
                            <el-tag type="warning" size="large" style="width: 130px;">
                                止损 {{ form.StopLoss }}%&nbsp;-&nbsp;{{ form.StopLossAmount }} U
                            </el-tag>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()" :loading="loading">确 定</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<style scoped>
.transamount {
    border-radius: 5px;
    background-color: #3a3a3a;
    font-size: 14px;
    color: white;
    height: 30px;
    padding-left: 20px;
    line-height: 30px;
    width: 285px;
}

.title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
}

.amount {
    font-size: 14px;
    font-weight: bold;
}

.green {
    color: #67c23a;
}

.red {
    color: #f56c6c;
}
</style>
<script setup>
import { ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import Decimal from 'decimal.js'
import * as constants from '@/utils/okxConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import Database from '@/service/database'
import { Helper } from '@/service'

const systemStore = useSystemStore()
const logStore = useLogStore()
const current = ref(systemStore.currentusymbol)
const dialogVisible = ref(false)
const loading = ref(false)
const allowTakeProfit = ref(true)
const allowStopLoss = ref(true)
const title = ref("")
const form = ref({
    Lever: "",
    TransAmount: "",
    TakeProfit: "",
    TakeProfitAmount: "",
    StopLoss: "",
    StopLossAmount: "",
    tpWorkingType: "",
    slWorkingType: "",
})
const tpId = ref("")
const slId = ref("")

const init = async (data) => {
    dialogVisible.value = true
    form.value = data
    title.value = `${current.value.symbol.replace("-SWAP", "")} ${current.value.okxConfig.marginType === constants.CROSS ? "全仓" : "逐仓"} ${data.posSide === constants.LONG ? "开多" : "开空"}  ×${data.Lever}`
    initWorkingType()
}

const submit = async () => {
    try {
        loading.value = true
        let symbol = systemStore.usymbols.find(x => x.symbol === current.value.symbol)

        //获取标记价格
        const markprice = await systemStore.publicClient.getMarkPrice("SWAP", current.value.symbol)
        let markPx = markprice.find(x => x.instId === current.value.symbol).markPx
        markPx = parseFloat(markPx)

        let amount = parseFloat(form.value.TransAmount)
        let ctVal = parseFloat(symbol.info.ctVal)     // 合约面值
        let minSz = parseFloat(symbol.info.minSz) // 最小下单数量 单位张
        let lotSz = parseFloat(symbol.info.lotSz)    // 下单数量精度 单位张

        //张数 = 成交量 ÷ 价格 ÷ 合约面值
        let sz = amount / markPx / ctVal
        if (sz < minSz) sz = minSz

        //根据精度调整小数
        const szDecimalPlaces = lotSz.toString().split('.')[1]?.length || 0
        sz = new Decimal(sz).toDecimalPlaces(szDecimalPlaces, Decimal.ROUND_FLOOR).toNumber()

        let _obj = {
            instId: current.value.symbol,
            ordType: "market",
            posSide: form.value.posSide,
            side: form.value.posSide === constants.LONG ? constants.BUY : constants.SELL,
            tdMode: current.value.okxConfig.marginType || constants.ISOLATED,
            sz: sz,
        }

        await systemStore.privateClient.placeOrder(_obj)
        ElMessage.success('开仓成功')

        loading.value = false
        dialogVisible.value = false

        //添加止盈止损
        try {

            //获取开仓均价
            let result = await systemStore.privateClient.getPositions()
            let positon = result.find(x => x.instId === current.value.symbol && x.posSide === form.value.posSide)
            let avgPx = parseFloat(positon.avgPx)

            //价格精度
            const priceDecimalPlaces = symbol.price.toString().split('.')[1]?.length || 0

            //计算止盈价格
            let tp = 0
            if (allowTakeProfit.value && form.value.TakeProfit) {
                const takeProfit = new Decimal(form.value.TakeProfit).div(100)
                const avgPxDecimal = new Decimal(avgPx)

                //做多
                if (form.value.posSide === constants.LONG)
                    tp = avgPxDecimal.times(new Decimal(1).plus(takeProfit))
                //做空
                if (form.value.posSide === constants.SHORT)
                    tp = avgPxDecimal.times(new Decimal(1).minus(takeProfit))
                tp = Math.abs(tp.toDecimalPlaces(priceDecimalPlaces, Decimal.ROUND_FLOOR).toNumber())
            }

            //计算止损价格
            let sl = 0
            if (allowStopLoss.value && form.value.StopLoss) {
                const stopLoss = new Decimal(form.value.StopLoss).div(100)
                const avgPxDecimal = new Decimal(avgPx)

                //做多
                if (form.value.posSide === constants.LONG)
                    sl = avgPxDecimal.times(new Decimal(1).minus(stopLoss))
                //做空
                if (form.value.posSide === constants.SHORT)
                    sl = avgPxDecimal.times(new Decimal(1).plus(stopLoss))
                sl = Math.abs(sl.toDecimalPlaces(priceDecimalPlaces, Decimal.ROUND_FLOOR).toNumber())
            }


            let ordType = constants.CONDITIONAL
            if (tp > 0 && sl > 0) ordType = constants.OCO

            let _attachObj = {
                instId: current.value.symbol,
                tdMode: current.value.okxConfig.marginType || constants.ISOLATED,
                side: form.value.posSide === constants.LONG ? constants.SELL : constants.BUY,
                posSide: form.value.posSide,
                ordType: ordType,
                closeFraction: "1",
            }

            if (tp > 0) {
                _attachObj.tpOrdPx = "-1"
                _attachObj.tpTriggerPx = tp
                _attachObj.tpTriggerPxType = form.value.tpWorkingType
            }

            if (sl > 0) {
                _attachObj.slOrdPx = "-1"
                _attachObj.slTriggerPx = sl
                _attachObj.slTriggerPxType = form.value.slWorkingType
            }

            await systemStore.privateClient.orderAlgo(_attachObj)

        } catch (error) {
            ElMessage.error('添加止盈止损失败' + error)
            logStore.addLog({
                title: '添加止盈止损失败',
                level: 'error',
                message: error
            })
        }

    } catch (error) {
        ElMessage.error('开仓失败' + error)
        loading.value = false
        logStore.addLog({
            title: '开仓失败',
            level: 'error',
            message: error
        })
    }
}

const initWorkingType = async () => {
    let workingTypes = await Database.select('WorkingType')
    let tp = workingTypes.find(x => x.Name == 'TP' && x.Platform == 'OKX')
    let sl = workingTypes.find(x => x.Name == 'SL' && x.Platform == 'OKX')

    tpId.value = tp ? tp.Id : Helper.NewId()
    slId.value = sl ? sl.Id : Helper.NewId()

    if (!tp) {
        Database.insert(
            "WorkingType",
            {
                Id: tpId.value,
                Platform: "OKX",
                Name: "TP",
                Type: constants.LAST
            }
        )
        tp = { Type: constants.LAST }
    }

    if (!sl) {
        Database.insert(
            "WorkingType",
            {
                Id: slId.value,
                Platform: "OKX",
                Name: "SL",
                Type: constants.LAST
            }
        )
        sl = { Type: constants.LAST }
    }

    form.value.tpWorkingType = tp.Type
    form.value.slWorkingType = sl.Type
}

const handleChange = async (type) => {
    if (type === "TP") {
        await Database.insert('WorkingType', {
            Id: tpId.value,
            Platform: "OKX",
            Name: "TP",
            Type: form.value.tpWorkingType
        })
    }

    if (type === "SL") {
        await Database.insert('WorkingType', {
            Id: slId.value,
            Platform: "OKX",
            Name: "SL",
            Type: form.value.slWorkingType
        })
    }
}

defineExpose({ init })

</script>